import { useMutation } from "react-query";
import { getBusLicenseAndPermitByRecordId } from "../../../../actions/CarrierAgreementMgmt/BusinessLicensesAndPermits";

export const useGetBusLicensePermitForEdit = () => {
  return useMutation(getBusLicenseAndPermitByRecordId);
};
